import { Typography } from 'antd';
import Image from 'next/image';
import React from 'react';

import { LineLarge } from '../../../../assets';
import { JumpStartDataProps } from '../../../utils/interfaces';

const { Text } = Typography;

interface ProfileProps {
  data: JumpStartDataProps;
}

interface JumpStartProps {
  data: JumpStartDataProps[];
}

const Profile: React.FC<ProfileProps> = ({ data }) => {
  const truncatedText = data?.disc;
  return (
    <>
      <span className=' xl:w-full flex justify-center'>
        <Image
          src={data.image}
          height={200}
          alt='Profile_1'
          className='object-contain  '
        />
      </span>
      <span className='flex flex-col text-textGray'>
        <p className='flex justify-center font-semibold xl:text-[20px] text-primary pt-4'>
          {data.title}
        </p>
        <span className=' flex justify-center text-textGray'>
          <Text className='xl:text-lg text-center min-h-32 text-fadedWhite'>
            {truncatedText}
            {/* <ShouldRender check={data?.disc.length > wordLimit}>
              <span
                className='text-xs whitespace-nowrap lg:text-base underline pl-2 cursor-pointer text-primary hover:text-darkPrimary'
                onClick={handleShowMoreClick}
              >
                {showMore ? 'Show less' : 'Show more'}
              </span>
            </ShouldRender> */}
          </Text>
        </span>
      </span>
    </>
  );
};

const JumpStart: React.FC<JumpStartProps> = ({ data }) => {
  return (
    <>
      <div className='w-full lg:pb-10 flex flex-col gap-y-4 lg:gap-y-3 text-fadedWhite'>
        <div className='flex flex-col text-center gap-y-2'>
          <span className='font-bold flex justify-center text-2xl xl:text-[36px]'>
            <div className='flex flex-col text-center sm:whitespace-nowrap xl:leading-10 text-fadedWhite'>
              <span className='font-bold md:w-min wh'>
                Upskill in your Career & Business
                <div className='w-fit hidden md:flex '>
                  <Image
                    src={LineLarge}
                    alt='LineLarge'
                    className='object-contain w-full h-full'
                  />
                </div>
              </span>
            </div>
          </span>
          <span className='text-center xl:text-[20px] flex justify-center text-textGray'>
            <p className='px-4 md:w-2/3 xl:w-2/5 xl:text-xl text-center text-fadedWhite'>
              Zebralearn Books open doors to those ready to take charge of their{' '}
              <b className=''>“Growth”</b> and become{' '}
              <b className=''>“Achievers” </b>
            </p>
          </span>
        </div>
        <div className='grid grid-cols-2 md:grid-cols-4 px-4 md:px-10 lg:px-24 pt-10 gap-y-5 gap-x-16'>
          {data?.map((item, index) => {
            return (
              <div key={`${item?.title}-${index}`} className=''>
                <Profile data={item} />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default JumpStart;
